import { render, staticRenderFns } from "./type60.vue?vue&type=template&id=59e675c8&scoped=true"
import script from "./type60.vue?vue&type=script&lang=js"
export * from "./type60.vue?vue&type=script&lang=js"
import style0 from "./type60.vue?vue&type=style&index=0&id=59e675c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e675c8",
  null
  
)

export default component.exports